
// import LRU from 'lru-cache'
// const CACHED = new LRU({
//     max: 100, // 缓存队列长度
//     ttl: 1000 * 5 // 缓存时间
// })

import course from "@/components/course.vue";
import noContent from "@/components/noContent.vue";

export default {
  components: { course },
  name: "index",
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "courses",
      meta: [
        {
          name: "keywords",
          content: "courses",
        },
        {
          name: "description",
          content: "official tutorial",
        },
      ],
    };
  },
  data() {
    return {
      asyncSource: [],
      total: "",
      pageSize: 20, //每页显示条目个数
      currentPage: parseInt(this.$route.query.page) || 1, //当前页
    };
  },
  async asyncData({ $global, query, error }) {
    let asyncSource = [];
    let total = 0;
    let banner = [];
    const res = await $global.courseList({
      page: query.page == undefined ? 1 : query.page,
    });
    try {
      if (res.code == 200) {
        asyncSource = res.data.video_list.data;
        total = res.data.video_list.total;
        banner = res.data.complaint;
      }
    } catch (e) {}
    return { asyncSource, total, banner };
  },
  watchQuery: ["page"],
  methods: {
    handleCurrentChange(val) {
      this.$router.push({ url: "/courses", query: { page: val } });
    },
  },
};
